import script from "./TopBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./TopBanner.vue?vue&type=script&setup=true&lang=js"

import "./TopBanner.vue?vue&type=style&index=0&id=4c87468a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c87468a"]])

export default __exports__